import { render } from "./VabeneFormEditorPage.vue?vue&type=template&id=5a12e136&scoped=true&ts=true"
import script from "./VabeneFormEditorPage.vue?vue&type=script&lang=ts"
export * from "./VabeneFormEditorPage.vue?vue&type=script&lang=ts"

import "./VabeneFormEditorPage.vue?vue&type=style&index=0&id=5a12e136&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a12e136"]])

export default __exports__